import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getWorkOrderTemplate } from '#/graphql/queries';
import type { GetWorkOrderTemplateQuery } from '#/graphql/types';

export const GET_WORK_ORDER_TEMPLATE = gql(getWorkOrderTemplate);

const useWOTemplateQuery = (id?: string) => {
  const query: QueryResult<GetWorkOrderTemplateQuery> = useQuery(GET_WORK_ORDER_TEMPLATE, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useWOTemplateQuery;
